import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'

export function getTrackedHours(t: TFunction): OnboardingStep {
  return {
    id: 'tracked_hours',
    type: 'custom',
    allowNext: true,
    wordings: {
      title: ''
    }
  }
}
